<template>
    <div class="position-relative">
        <loading v-if="loading !== 0"></loading>
        <div class="container py-3">
            <div class="breadcrumbs-retos text-bat">
                <a href="/home-bat">
                    <img src="/img/icons/homeBread.svg" alt="" />
                </a>
                <span class="color-active-miga link"><strong>Descuentos</strong></span>
            </div>

            <div class="text-bat mt-3">
                <h5 class="text-blue">Descuentos</h5>
                <p class="fs-6">{{ discounts.length }} cupones</p>
                <span class="pt-3 fs-6">Conectados trae descuentos exclusivos para ti, <strong>no tienes que usar tus puntos</strong>,
                    estarán disponibles para que los uses en tus tiendas más cercanas.</span>
            </div>

            <div class="py-2 py-lg-4 mt-2">
                <h5>Últimos descuentos agregados</h5>
                <slick v-if="recent_discounts.length" ref="slick" :options="slickRecentDiscounts" class="p-2 slick-vue">
                    <div v-for="discount in recent_discounts" class="p-2">
                        <div class="bg-white rounded-3 text-bat border border-primary">
                            <div class="row justify-content-between">
                                <div class="col-7 px-4 border-right border-dark p-2">
                                    <div class="row d-flex justify-content-between">
                                        <div class="col-7 pe-0">
                                            <h5 class="text-title-bat fs-6 mb-0 truck-title">{{ discount.category_name }}</h5>
                                        </div>
                                        <div class="col-4 px-0">
                                            <span class="tag-category">{{ discount.alliance_name }}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto pe-0 ">
                                            <h4 class="fs-2 mb-0">{{ discount.discount }}%</h4>
                                        </div>
                                        <div class="col-4 ps-0">
                                            <p class="lh-base mb-0 fs-7 pt-0 pt-md-1 ">de Descuento</p>
                                        </div>
                                    </div>
                                    <a class="text-title-bat text-indigo text-decoration-none" :href="'/coupon/' + discount.id + '/detail'">Ver detalle ></a>
                                </div>
                                <div class="col-5 ticket-img ps-1">
                                    <div class="box-img position-relative w-100 h-100">
                                        <img class="w-100 h-100 rounded-end" :src="url_media + discount.short_image" :alt="discount.category_name">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slick>
            </div>

            <div>
                <h5>Más relevantes</h5>
                <slick v-if="discounts.length" ref="slick" :options="slickOptionsDiscounts" class="p-2 slick-vue">
                    <div v-for="(chunk, index) in discounts_chunk" v-if="index < 3">
                        <div v-for="discount in chunk" class="p-2">
                            <div class="bg-white rounded-3 text-bat border border-primary">
                                <div class="row justify-content-between">
                                    <div class="col-7 px-4 border-right border-dark p-2">
                                        <div class="row d-flex justify-content-between">
                                            <div class="col-7 pe-0">
                                                <h5 class="text-title-bat fs-6 mb-0 truck-title">{{ discount.category_name }}</h5>
                                            </div>
                                            <div class="col-4 px-0">
                                                <span class="tag-category">{{ discount.alliance_name }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-auto pe-0 ">
                                                <h4 class="fs-2 mb-0">{{ discount.discount }}%</h4>
                                            </div>
                                            <div class="col-4 ps-0">
                                                <p class="lh-base mb-0 fs-7 pt-0 pt-md-1">de Descuento</p>
                                            </div>
                                        </div>
                                        <a class="text-title-bat text-indigo text-decoration-none" :href="'/coupon/' + discount.id + '/detail'">Ver detalle ></a>
                                    </div>
                                    <div class="col-5 ticket-img ps-1">
                                        <div class="box-img position-relative w-100 h-100">
                                            <img class="w-100 h-100 rounded-end" :src="url_media + discount.short_image" :alt="discount.category_name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slick>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from "vue-slick";
import 'slick-carousel/slick/slick.css';

export default {
    components: {Slick},
    props: {
        url_media: {
            default: '',
        },
    },
    data() {
        return {
            loading: 0,
            discounts: [],
            recent_discounts: [],
            discounts_chunk: [],
            slickOptionsDiscounts: Object,
            slickRecentDiscounts: Object,
        }
    },
    mounted() {
        this.slickRecentProps()
        this.slickOptionsProps()
        this.loadAlliances()
    },
    methods: {
        loadAlliances() {
            this.loading++
            axios.get(`get-discounts-data`)
                 .then(({data}) => {
                     this.discounts = data.discounts
                     this.recent_discounts = data.recent_discounts
                     this.discounts_chunk = data.discounts_chunk
                     this.loading--
                 })
        },
        slickOptionsProps() {
            this.slickOptionsDiscounts = {
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }
        },
        slickRecentProps() {
            this.slickRecentDiscounts = {
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 3000,
                slidesToShow: 3,
                slidesToScroll: 2,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }
        },
    }
}
</script>
